<template>
	<div>
		<winning-numbers-sidebar :open.sync="sidebarOpen" :results="externalLotteriesResults"></winning-numbers-sidebar>
		<v-btn id="external-results-btn" @click="sidebarOpen = !sidebarOpen" style="z-index: 4">
			Winning Numbers
		</v-btn>
		<v-row>
			<v-img contain height="200" :src="require('@/assets/img/argentinaLottery/logo.png')"></v-img>
		</v-row>
		<v-row justify="center">
			<v-col cols="auto">
				<v-btn id="see-it-live-btn" color="primary" @click="scrollToStream">
					Check our livestream
				</v-btn>
			</v-col>
		</v-row>
		<v-row justify="center" class="mb-5">
			<v-col
				xl="2"
				lg="3"
				md="4"
				sm="6"
				cols="12"
				v-for="(result, index) in results"
				:key="`${result.date}-${result.sortition.id}`"
			>
				<card class="result-card rounded-xl" :class="{'last-winning': index === 0}" :result="result"
							:pick-three-image="{ src: require('@/assets/img/argentinaLottery/pickThree.webp'), width: '90px', height: '50px',contain: true }"
							:pick-four-image="{ src: require('@/assets/img/argentinaLottery/pickFour.webp'), width: '90px', height: '50px', contain: true }">
					<template #sortition-area="{date, sortition}">
						<v-row align="center">
							<v-col md="12">
								<v-img contain height="150" :src="require('@/assets/img/argentinaLottery/logo.png')"></v-img>
							</v-col>
							<v-col md="12">
								<h2 class="sortition-name">{{ sortition.abbreviation }}</h2>
								<h5 class="mb-0">
									{{ date }}
								</h5>
								<v-chip v-if="index === 0" color="success" class="font-weight-bold">Last Winner</v-chip>
							</v-col>
						</v-row>
					</template>
				</card>
			</v-col>
		</v-row>

		<v-responsive :aspect-ratio="16 / 9">
			<iframe
				v-if="channelName && channelName.length > 0"
				id="frame"
				:src="
          `https://player.twitch.tv/?channel=${channelName}&parent=argentinalot.tv&parent=localhost`
        "
				frameborder="0"
				scrolling="no"
				allowfullscreen="true"
			>
			</iframe>
		</v-responsive>
	</div>
</template>

<script>
import BaseStream from "@homepage/components/pageStyles/BaseStream";
import {generateImageMapFor} from "@homepage/helpers/image";
import Card from "@homepage/components/streams/cards/Card.vue";

export default {
	name: "TripleplayLotteryStream",
	components: {
		Card
	},
	extends: BaseStream,
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
		};
	},
};
</script>

<style scoped lang="scss">
@import './common.scss';

.result-card {
	color: white;
	border: 4px solid #eac627;
	background-color: #4b94cb8c;
	-webkit-backdrop-filter: blur(5px);
	backdrop-filter: blur(5px);
}

.sortition-name {
	word-break: keep-all;
}

@keyframes blink-border {
	from {
		border: 3px solid #4b94cb8c;
		box-shadow: 0 0 25px black;
	}
	to {
		border: 3px solid #f2bc00a1;
		box-shadow: 0 0 25px #818181;
	}
}

.last-winning {
	transition: border, box-shadow;
	animation: blink-border 500ms infinite alternate ease;
}
</style>

<style>

#inspire {
	background-image: url("../../../assets/img/argentinaLottery/background.webp");
	//background-repeat: repeat !important;
	//background-size: 400px 400px !important;
}
</style>
